import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import Ajax from "Pub/js/ajax";
import { connect } from "react-redux";
import { Tree, Button, Checkbox, Select, Tooltip, Input } from "antd";
import HotKeysModal from "Components/HotKeysModal";
import * as utilService from "./utilService";
import { opersignNameObj, colorObj } from "./utilService";
import { langCheck, DeferFn, debounce } from "Pub/js/utils";
import { selectCardFromOther } from "./events";
import { updateSelectCard, updateSelectArea } from "Store/ZoneSetting/action";
import platform from "Pub/js/platform";
import MetaTreeModel from './metatree/MetaTreeModel';
import { queryMetaTreeData, asyncQueryMetaPro, createMetaTreeIns, appendMetaTreeNodes, queryMetaPropByKeyWords } from './metatree/MetaTreeTools';
const { NCDiv, NCCheckbox, NCTree, NCFormControl } = platform.base;
const TreeNode = NCTree.NCTreeNode;
const Search = Input.Search;
const Option = Select.Option;
const ShowTreeNodeSelect = false;
//添加元数据模态框组件
class TreeModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checkedKeys: [],
            selectedKeys: [],
            selectedNodes: [],
            searchValue: "",
            needToBeAllSelectNodeList: [],
            expandedKeys: [],
            searchExpandedKeys: [],
            searchSelectedKeys: [],
        };
    }
	//设置模态框隐藏
	showModalHidden = () => {
	    this.setModalVisible(false);
	};
	//设置模态框隐藏，并归零元数据树的数据
	setModalVisible = modalVisible => {
	    this.setState({
	        selectedKeys: [],
	        checkedKeys: [],
	        selectedNodes: [],
	        checkedNodes: [],
	        needToBeAllSelectNodeList: [],
	        searchValue: '',
	        expandedKeys: [],
	        searchExpandedKeys: [],
	        searchSelectedKeys: [],
	    });
	    this.props.setModalVisible(modalVisible);
	};
	//移动到的弹出框中，点击确认
	onOkMoveDialog = () => {
	    const modalVisible = false;
	    const { selectedNodes } = this.state;
	    const { targetAreaID, json } = this.props;
	    let cardList = [];
	    //循环遍历已经选择的节点，进行查询区/非查询区的数据初始化
	    _.forEach(selectedNodes, (s, i) => {
	        const {
	            myUniqID,
	            datatype,
	            refname,
	            refcode,
	            pid,
	            refpk,
	            isLeaf,
	            modelname,
	            length,
	            notSearchAreaCode,
	            proid,
	            resid,
	            readonly,
	        } = s.props.dataRef;
	        let cardObj = {};
	        //查询区
	        if (this.props.targetAreaType === "0") {
	            //操作符编码
	            const opersign = utilService.getObjNameByDatatype(datatype, utilService.opersignObj);
	            //操作符名称
	            const opersignname = utilService.getObjNameByDatatype(datatype, opersignNameObj());
	            cardObj = {
	                pk_query_property: `newMetaData_${myUniqID}`,
	                areaid: targetAreaID,
	                datatype: datatype,
	                code: myUniqID,
	                label: refname,
	                metapath: myUniqID,
	                isnotmeta: false,
	                isuse: true,
	                opersign: opersign ? opersign : "=@>@>=@<@<=@like@",
	                opersignname: opersignname
	                    ? opersignname
	                    : langCheck(
	                        "ZoneSetting-000001",
	                        "pages",
	                        json,
						  ) /* 国际化处理： 等于@大于@大于等于@小于@小于等于@相似@*/,
	                defaultvalue: "",
	                isfixedcondition: false,
	                required: false,
	                disabled: false,
	                visible: datatype === "56" ? false : true,
	                ismultiselectedenabled: false,
	                isquerycondition: true,
	                refname: datatype === "204" ? modelname : "-99",
	                containlower: isLeaf ? false : true,
	                ischeck: false,
	                isbeyondorg: false,
	                usefunc: datatype === "34" ? true : false,
	                showtype: "1",
	                returntype: "refpk",
	                define1: "",
	                define2: "",
	                define3: "",
	                define4: "",
	                define5: "",
	                itemtype: "input",
	                myrefpk: refpk,
	                visibleposition: "",
	                tablecode: "",
	                querytablename: "",
	                maxlength: length, //查询区新增元数据赋值
	            };
	        } else {
	            //非查询区
	            cardObj = {
	                pk_query_property: `newMetaData_${myUniqID}`,
	                areaid: targetAreaID,
	                code: notSearchAreaCode ? notSearchAreaCode : myUniqID,
	                datatype: datatype,
	                label: refname,
	                metapath: myUniqID,
	                color: colorObj() && colorObj()[0].value, //取常量中默认颜色
	                isrevise: false,
	                required: false,
	                disabled: false,
	                visible: datatype === "56" ? false : true,
	                maxlength: length,
	                defaultvalue: "",
	                hyperlinkflag: false, //超链接
	                defaultvar: "",
	                define1: "",
	                define2: "",
	                define3: "",
	                itemtype: "input",
	                myrefpk: refpk,
	            };
	        }
	        if (this.props.targetAreaType === "1") {
	            //表单
	            cardObj.colnum = "1";
	            cardObj.isnextrow = false;
	        }
	        if (this.props.targetAreaType === "2") {
	            //表格
	            cardObj.width = "";
	            cardObj.istotal = false;
	        }
	        //参照
	        if (cardObj.datatype === "204") {
	            cardObj.metaid = refpk;
	            cardObj.iscode = false;
	            cardObj.modelname = modelname;
	        }
	        //自定义项
	        if (cardObj.datatype === "56") {
	            cardObj.isdefined = true;
	        }
	        //小数或者金额
	        if (cardObj.datatype === "31" || cardObj.datatype === "52") {
	            cardObj.dataval = "2,,";
	        }
	        //组件类型
	        cardObj.itemtype = utilService.getItemtypeByDatatype(cardObj.datatype);
	        //查询区的若干逻辑组件，默认值设为false
	        // if (this.props.targetAreaType === "0" && _.includes(utilService.shouldSetDefaultValueList, cardObj.itemtype)) {
	        //     cardObj.defaultvalue='false'
	        // }
	        //新增了两个属性
	        cardObj.proid = proid;
	        cardObj.resid = resid;
	        if (readonly === true) {
	            cardObj.disabled = true;
	        }
	        cardList.push(cardObj);
	    });
	    //查询区&非查询区枚举类型需要添加默认dataval
	    let ajaxDataForSelect = [];
	    _.forEach(cardList, c => {
	        if (c.datatype === "203") {
	            console.log(c.label);
	            ajaxDataForSelect.push(c.myrefpk);
	        }
	    });
	    //若存在枚举类型，
	    if (ajaxDataForSelect.length > 0) {
	        Ajax({
	            url: `/nccloud/platform/templet/getEnumValue.do`,
	            info: {
	                name: langCheck(
	                    "ZoneSetting-000017",
	                    "pages",
	                    json,
	                ) /* 国际化处理： 单据模板设置*/,
	                action: langCheck(
	                    "ZoneSetting-000122",
	                    "pages",
	                    json,
	                ), /* 国际化处理： 下拉选项*/
	            },
	            data: ajaxDataForSelect,
	            success: res => {
	                if (res) {
	                    let { data, success } = res.data;
	                    if (success && data) {
	                        _.forEach(data, d => {
	                            _.forEach(cardList, c => {
	                                _.forEach(d, d2 => {
	                                    if (d2.id === c.myrefpk) {
	                                        if (_.isEmpty(c.dataval)) {
	                                            c.dataval = `${d2.name}=${d2.value}`;
	                                        } else {
	                                            c.dataval = `${c.dataval},${d2.name}=${d2.value}`;
	                                        }
	                                    }
	                                });
	                            });
	                        });
	                    }
	                    this.setDatavalForCard(cardList, modalVisible);
	                }
	            },
	        });
	    } else {
	        this.setDatavalForCard(cardList, modalVisible);
	    }
	};
	//非查询区的参照类型需要添加默认dataval
	setDatavalForCard = (cardList, modalVisible) => {
	    let { json } = this.props;
	    // if (this.props.targetAreaType !== "0") {
	    let ajaxData = [];
	    _.forEach(cardList, c => {
	        if (c.datatype === "204") {
	            ajaxData.push(c.modelname);
	        }
	    });
	    if (ajaxData.length > 0) {
	        Ajax({
	            url: `/nccloud/platform/templet/getRefDefaultSel.do`,
	            info: {
	                name: langCheck(
	                    "ZoneSetting-000017",
	                    "pages",
	                    json,
	                ) /* 国际化处理： 单据模板设置*/,
	                action: langCheck(
	                    "ZoneSetting-000024",
	                    "pages",
	                    json,
	                ), /* 国际化处理： 查询参照默认下拉选项*/
	            },
	            data: ajaxData,
	            success: res => {
	                if (res) {
	                    let { data, success } = res.data;
	                    if (success && data) {
	                        _.forEach(data, d => {
	                            _.forEach(cardList, c => {
	                                if (d.name === c.modelname) {
	                                    c.dataval = `${d.pk_refinfo},code=1`;
	                                    c.refname = d.name;
	                                    c.refcode = d.refpath;
	                                }
	                            });
	                        });
	                    }
	                    cardList[0] && selectCardFromOther.call(this, cardList[0]);
	                    this.props.addCard(cardList);
	                    this.setModalVisible(modalVisible);
	                }
	            },
	        });
	    } else {
	        cardList[0] && selectCardFromOther.call(this, cardList[0]);
	        this.props.addCard(cardList);
	        this.setModalVisible(modalVisible);
	    }
	    // } else {
	    // 	cardList[0] && selectCardFromOther.call(this, cardList[0]);
	    // 	this.props.addCard(cardList);
	    // 	this.setModalVisible(modalVisible);
	    // }
	};
	//关于树的方法
	//选中事件，设置selectKeys和SelectNodes
	onSelect = (selectedKeys, info) => {
	    // this.setState({ selectedKeys, selectedNodes: info.selectedNodes });
	    this.setState({
	        checkedKeys: selectedKeys,
	        selectedKeys: selectedKeys,
	        selectedNodes: info.selectedNodes,
	        checkedNodes: info.selectedNodes,
	    });
	};
	//复选框选中事件，设置checkedKeys
	onCheck = (checkedKeys, info) => {
	    // this.setState({
	    //     checkedKeys,
	    //     checkedNodes: info.checkedNodes
	    // });
	    this.setState({
	        selectedKeys: checkedKeys,
	        checkedKeys: checkedKeys,
	        checkedNodes: info.checkedNodes,
	        selectedNodes: info.checkedNodes, //关联checkedbox和文本选中数据
	    });
	};
	//递归调用，渲染树节点
	renderTreeNodes = data => {
	    return data.map(item => {
	        const fieldidClassName = `fieldid_${item.refcode}_node`; //自动化测试标记
	        if (item.children) {
	            return (
	                <TreeNode
	                    title={item.title}
	                    // switcherIcon={({ expanded }) => {
	                    //     return (
	                    //         <i
	                    //             className={`font-size-18 iconfont ${
	                    //                 expanded
	                    //                     ? "icon-shu_zk"
	                    //                     : "icon-shushouqi"
	                    //             }`}
	                    //         />
	                    //     );
	                    // }}
	                    key={item.key}
	                    dataRef={item}
	                    className={fieldidClassName}>
	                    {this.renderTreeNodes(item.children)}
	                </TreeNode>
	            );
	        }
	        if (item.isleaf) {
	            return <TreeNode {...item} dataRef={item} className={fieldidClassName} />;
	        } else {
	            return (
	                <TreeNode
	                    // switcherIcon={({ expanded }) => {
	                    //     return (
	                    //         <i
	                    //             className={`font-size-18 iconfont ${
	                    //                 expanded
	                    //                     ? "icon-shu_zk"
	                    //                     : "icon-shushouqi"
	                    //             }`}
	                    //         />
	                    //     );
	                    // }}
	                    {...item}
	                    dataRef={item}
	                    className={fieldidClassName}
	                />
	            );
	        }
	    });
	};
	//异步树，点击展开，发送ajax请求
	onLoadData = treeNode => {
	    let { json } = this.props;
	    return new Promise(resolve => {
	        if (treeNode.props.children) {
	            resolve();
	            return;
	        }
	        Ajax({
	            url: `/nccloud/platform/templet/querymetapro.do`,
	            info: {
	                name: langCheck(
	                    "ZoneSetting-000017",
	                    "pages",
	                    json,
	                ) /* 国际化处理： 单据模板设置*/,
	                action: langCheck(
	                    "ZoneSetting-000020",
	                    "pages",
	                    json,
	                ), /* 国际化处理： 元数据树结构查询*/
	            },
	            data: {
	                // metaid: metaid
	                metaid: treeNode.props.refpk,
	            },
	            success: res => {
	                if (res) {
	                    let { data, success } = res.data;
	                    if (success && data && data.rows && data.rows.length > 0) {
	                        let metaTree = [];
	                        data.rows.map((r, index) => {
	                            let tmpMetaTree = {
	                                ...r,
	                                title: `${r.refcode} ${r.refname}`,
	                                key: `${treeNode.props.myUniqID}.${r.refcode}`,
	                                myUniqID: `${treeNode.props.myUniqID}.${r.refcode}`,
	                                isLeaf: r.isleaf,
	                            };
	                            //非查询区域的子表里的code不是全路径
	                            if (
	                                this.props.targetAreaType !== "0" &&
									treeNode.props.notSearchAreaCode
	                            ) {
	                                tmpMetaTree.notSearchAreaCode = `${treeNode.props.notSearchAreaCode}.${r.refcode}`;
	                            }
	                            //非查询区域的子表的code，若父级是205则直接为自身refcode
	                            if (
	                                this.props.targetAreaType !== "0" &&
									treeNode.props.datatype === "205"
	                            ) {
	                                tmpMetaTree.notSearchAreaCode = `${r.refcode}`;
	                            }
	                            metaTree.push(tmpMetaTree);
	                        });
	                        treeNode.props.dataRef.children = [].concat(metaTree);
	                        this.props.updateMetaTreeData([...this.props.metaTree]);
	                        resolve();
	                    }
	                }
	            },
	        });
	    });
	};
	getContentDom = () => {
	    const { metaTree } = this.props;
	    return (
	        <div className='template-setting-left-sider template-setting-sider'>
	            {this.getModalTitleDom()}
	            <div className='sider-content meta-tree'>
	                <NCDiv className='sider-tree' fieldid='addMeta' areaCode={NCDiv.config.TreeCom}>
	                    <NCTree
	                        checkable
	                        checkStrictly={true}
	                        loadData={this.onLoadData}
	                        showLine={true}
	                        multiple={true}
	                        onSelect={this.onSelect}
	                        selectedKeys={this.state.selectedKeys}
	                        checkedKeys={this.state.checkedKeys}
	                        onCheck={this.onCheck}
	                        fieldid='meta'>
	                        {this.renderTreeNodes(metaTree)}
	                    </NCTree>
	                </NCDiv>
	            </div>
	        </div>
	    );
	};
	//选择/取消选择所有的节点，且205数据类型不选中
	selectAllTreeNode = (isChecked, metaTreeNodeList) => {
	    let { selectedKeys, checkedKeys } = this.state;
	    selectedKeys = _.cloneDeep(selectedKeys);
	    if (isChecked) {
	        //循环遍历树结构，只选中非205的数据类型
	        //循环遍历树结构，只选中非205的数据类型
	        _.forEach(metaTreeNodeList, (m, i) => {
	            if (selectedKeys.indexOf(m.myUniqID) === -1 && m.datatype !== "205") {
	                selectedKeys.push(m.myUniqID);
	                this.state.selectedNodes.push({ props: { dataRef: { ...m } } });
	            }
	        });
	    } else {
	        _.forEach(metaTreeNodeList, (m, i) => {
	            _.remove(selectedKeys, n => {
	                return n === m.myUniqID;
	            });
	        });
	        _.forEach(metaTreeNodeList, (m, i) => {
	            _.remove(this.state.selectedNodes, n => {
	                return n.props.dataRef.myUniqID === m.myUniqID;
	            });
	        });
	    }
	    this.setState({
	        selectedKeys,
	        checkedKeys: selectedKeys,
	    });
	};
	//下拉选择205类型的节点
	handleChangeSelectTreeNode = value => {
	    const { metaTree, canSelectTreeNodeList } = this.props;
	    //循环遍历204类型的节点
	    _.forEach(canSelectTreeNodeList, m => {
	        if (value.indexOf(`${m.refcode} ${m.refname}`) === -1) {
	            if (m.children !== null) {
	                setTimeout(() => {
	                    this.selectAllTreeNode(false, m.children);
	                }, 0);
	            }
	        } else {
	            if (m.children !== null) {
	                setTimeout(() => {
	                    this.selectAllTreeNode(true, m.children);
	                }, 0);
	            }
	        }
	    });

	    this.setState({ needToBeAllSelectNodeList: value });
	};
	/**
	 * 处理搜索框
	 * @param {Object} e 事件对象
	 */
	onSearchFieldChange = e => {
	    let { origTree, searchField, updateMetaTree } = this.props;
	    const value = e.target.value;
	    // this.setState({
	    // 	searchValue: value
	    // });
	    let handleFn = (value => {
	        return () => {
	            let { origTree } = this.props;
	            if (value.length === 0) {
	                this.setState({ searchExpandedKeys: [] });
	                updateMetaTree(origTree, origTree);
	            }
	            this.setState({ searchValue: value });
	        };
	    })(value);
	    debounce(handleFn, 300)();
	}
	/**
	 * 处理清空搜索关键词
	 * @param {Object} e 事件请求
	 */
	onSearchFieldClean = e => {
	    let { origTree, updateMetaTree, searchField } = this.props;
	    ReactDOM.findDOMNode(searchField).querySelector('.ant-input').value = '';
	    this.setState({
	        searchValue: '',
	        searchExpandedKeys: [],
	        curTree: origTree,
	    });
	    updateMetaTree(origTree, origTree);
	}
    /**
     * 处理关键字搜索meta字段
     * @param {String} value 关键字
     */
    onSearchMeta = value => {
        if (!value) {
            return;
        }
        let { origTree, updateMetaTree } = this.props;
        let { searchTreeData, searchSelectedKeys } = this.state;
        let searchExpandedKeys = [];
        let nextTree = queryMetaPropByKeyWords.call(this, value, origTree, searchExpandedKeys);
        let resultTreeData = nextTree.getMetaTreeData();
        let metaTree = resultTreeData.children;
        if (nextTree.getRoot().children.length > 0) {
            this.setState({
                searchExpandedKeys,
                searchSelectedKeys,
            });
            updateMetaTree(origTree, nextTree);
        } else {
            this.setState({
                searchExpandedKeys: [],
                searchSelectedKeys: [],
            });
        }
    }
	//模态框的标题部分
	getModalTitleDom = () => {
	    let { json } = this.props;
	    let { searchValue } = this.state;
	    return (
	        <div className='customer-header'
	            style={{ height: this.props.canSelectTreeNodeList.length > 0 && ShowTreeNodeSelect ? '80px' : '40px' }}
	        >
	            <div className="metatree-search-input" style={{ width: '250px', display: 'inline-block' }}>
	                <Search
	                    ref={el => this.props.searchField = el}
	                    className="dnd-cancel"
	                    // value={searchValue}
	                    // 国际化处理： 搜索
	                    placeholder={langCheck('ZoneSetting-000322', 'pages', json)}
	                    onChange={this.onSearchFieldChange}
	                    onSearch={this.onSearchMeta}
	                />
	                {
	                    searchValue && <i className="icon iconfont icon-qingkong" onClick={this.onSearchFieldClean}></i>
	                }
	            </div>

	            <NCCheckbox
	                className='dnd-cancel' //必须加。不加的话不能触发click事件
	                onChange={val => {
	                    this.selectAllTreeNode(val, this.props.metaTree);
	                }}>
	                {langCheck("ZoneSetting-000125", "pages", json)}
	                {/* /* 国际化处理： 全选根节点*/}
	            </NCCheckbox>
	            {(() => {
	                if (this.props.canSelectTreeNodeList.length > 0 && ShowTreeNodeSelect) {
	                    return (
	                        <div fieldid='root' style={{ margin: '5px 8px' }}>
	                            <Select
	                                className='dnd-cancel' //必须加。不加的话不能触发click事件
	                                maxTagCount={1}
	                                size='small'
	                                style={{ width: "50%" }}
	                                multiple={true}
	                                mode='multiple'
	                                placeholder={langCheck(
	                                    "ZoneSetting-000126",
	                                    "pages",
	                                    json,
	                                )} /* 国际化处理： 请先展开对应树节点，再选择*/
	                                onChange={this.handleChangeSelectTreeNode}
	                                value={this.state.needToBeAllSelectNodeList}
	                                dropdownClassName='fieldid_root_select'>
	                                {this.props.canSelectTreeNodeList.map(
	                                    (node, index) => {
	                                        return (
	                                            <Option
	                                                key={`${node.refcode} ${node.refname}`}
	                                                disabled={
	                                                    node.children
	                                                        ? false
	                                                        : true
	                                                }>
	                                                {node.refcode}{" "}
	                                                {node.refname}
	                                            </Option>
	                                        );
	                                    },
	                                )}
	                            </Select>
	                        </div>
	                    );
	                }
	            })()}
	        </div>
	    );
	};
    /**
     * 异步加载树的子节点数据
     * @param {Object} treeNode 树节点
     */
    onLoadSubTreeData = treeNode => {
        let { origTree, curTree, updateMetaTree } = this.props;
        let { searchValue } = this.state;
        let { children, refpk, myUniqID, datatype, dataRef } = treeNode.props;
        let curNode = origTree.getNode(n => n.data.myUniqID === myUniqID);
        let searchExpandedKeys = [];
        return new Promise(resolve => {
            if (children) {
                resolve();
                return;
            }
            asyncQueryMetaPro.call(this, refpk).then(data => {
                let tree = origTree,
                    nextTree = [];
                if (searchValue) {
                    nextTree = appendMetaTreeNodes.call(this, data.rows, myUniqID, curTree);
                    // nextTree = queryMetaPropByKeyWords.call(this, searchValue, selectTree, searchExpandedKeys);
                } else {
                    tree = appendMetaTreeNodes.call(this, data.rows, myUniqID, origTree);
                    nextTree = queryMetaPropByKeyWords.call(this, searchValue, tree, searchExpandedKeys);
                }
                updateMetaTree(tree, nextTree);
                let metaTreeRootData = tree.getMetaTreeData();
                this.props.updateMetaTreeData(metaTreeRootData.children);
                // this.setState({ searchExpandedKeys })
                resolve();
            });
        });

    }
    /**
     * 选择meta tree树节点， 设置selectKeys和SelectNodes
     * @param {Array} selectedKeys 节点keys
     * @param {Object} info 树组件数据
     */
    onSelectTreeNode = (selectedKeys, info) => {
        this.setState({
            selectedKeys,
            searchSelectedKeys: selectedKeys,
            checkedKeys: selectedKeys,
            selectedNodes: info.selectedNodes,
            checkedNodes: info.selectedNodes,
        });

    }
    /**
     * 复选框选中事件，设置checkedKeys
     * @param {Array} checkedKeys 节点keys
     * @param {Object} info 树组件数据
     */
    onCheckTreeNode = (checkedKeys, info) => {
        this.setState({
            selectedKeys: checkedKeys,
            searchSelectedKeys: checkedKeys,
            checkedKeys: checkedKeys,
            checkedNodes: info.checkedNodes,
            //关联checkedbox和文本选中数据
            selectedNodes: info.checkedNodes,
        });
    }
    /**
     * 展开节点
     * @param {Array} expandedKeys 展开节点keys
     * @param {Object} item 节点状态
     * @param {String} type 类型
     */
    onExpandTreeNode = (expandedKeys, item, type) => {
        let { expanded, node } = item;
        let myUniqID = _.result(node, 'props.dataRef.myUniqID');
        if (expanded === false) {
            expandedKeys = _.filter(expandedKeys, el => el.indexOf(myUniqID) === -1);
        }
        if (type === 'search') {
            this.setState({ searchExpandedKeys: expandedKeys });
        } else {
            this.setState({ expandedKeys });
        }
    }
	createCodeObject = () => {
	    let { areaList, targetAreaID } = this.props;
	    let codeObj = {};
	    let areaItem = areaList.find(item => item && item.pk_area === targetAreaID);
	    let queryPropertyList = areaItem && areaItem.queryPropertyList;
	    queryPropertyList && queryPropertyList.forEach(item => {
	        codeObj[item.proid] = item.proid;
	    });
	    return codeObj;
	};
    /**
     * 渲染单个节点
     * @param {Node} node 节点实例
     * @param {Map} map 节点Map
     */
    renderMetaTreeNode = (node, map) => {
        let { searchValue, expandedKeys } = this.state;
        let { data, parent, children } = node;
        let { children:childrenInfo, ...item } = data;
        let { refcode, title, proid, key, isLeaf } = item;
		const codeObject = this.createCodeObject();
        // 自动化测试标记
        let fieldidClassName = `fieldid_${refcode}_node`;
		if (codeObject[proid]) {
			fieldidClassName += ' tree-node-disabled';
		}
        const index = title.search(searchValue);
        const beforeStr = title.substr(0, index);
        const afterStr = title.substr(index + searchValue.length);
        let titleEl = index > -1 ? (
            <span>
                {beforeStr}
                <span className="wui-tree-searchable-filter">{searchValue}</span>
                {afterStr}
            </span>
        ) : (
            <span>{ title }</span>
        );
        let iconEl = (
            <span className={`icon iconfont ${expandedKeys.includes(refcode)
                ? 'icon-wenjianjiadakai' : 'icon-wenjianjia'}`
            }/>
        );
        let el;
        if (children.length > 0) {
            let childrenEls = children.map(childNode => {
                let el = map.get(childNode);
                return el;
            });
            el = React.createElement(TreeNode, {
                key: key,
                dataRef: item,
                className: `${fieldidClassName}`,
                icon: iconEl,
                title: titleEl,
            }, childrenEls);
        } else {
            if (isLeaf) {
                el = (
                    <TreeNode
                        {...item}
                        dataRef={item}
                        className={`${fieldidClassName}`}
                        title={titleEl}
                    />
                );
            } else {
                el = (
                    <TreeNode
                        {...item}
                        dataRef={item}
                        className={`${fieldidClassName}`}
                        icon={iconEl}
                        title={titleEl}
                    />
                );
            }
        }
        return el;
    }
    /**
     * 渲染元数据树节点
     */
    renderMetaTreeNodes = () => {
        let { curTree } = this.props;
        if (!(curTree instanceof MetaTreeModel)) {
            return null;
        }
        console.time(`RenderMetaTreeNodes`);
        console.time(`SerializeMetaTreeNodes`);
        let serializeTree = MetaTreeModel.serialize(curTree);
        console.timeEnd(`SerializeMetaTreeNodes`);
        let reverseNodes = serializeTree.nodes.reverse();
        let root = curTree.getRoot();
        let map = new Map();
        reverseNodes.forEach(node => {
            let el = this.renderMetaTreeNode(node, map);
            map.set(node, el);
        });
        console.timeEnd(`RenderMetaTreeNodes`);
        return root.children.map(node => {
            return map.get(node);
        });
    }
    /**
     * 渲染元数据树
     * @param {String} type [default|search]
     */
    renderMetaTree = (type = 'default') => {
        let { metaTree, origTree, curTree } = this.props;
        let { expandedKeys, selectedKeys, checkedKeys, searchSelectedKeys, searchExpandedKeys, searchValue } = this.state;
        if (type === 'search') {
            selectedKeys = searchSelectedKeys;
            expandedKeys = searchExpandedKeys;
        }
        return (
            <NCTree
                fieldid="meta"
                checkable
                showIcon
                checkStrictly={true}
                checkable={true}
                showLine={true}
                multiple={true}
                selectedKeys={selectedKeys}
                checkedKeys={checkedKeys}
                expandedKeys={expandedKeys}
                loadData={this.onLoadSubTreeData}
                onSelect={this.onSelectTreeNode}
                onCheck={this.onCheckTreeNode}
                onExpand={(expandedKeys, item) => {this.onExpandTreeNode(expandedKeys, item, type);}}
            >
                {this.renderMetaTreeNodes()}
            </NCTree>
        );
    }
    renderModalContent() {
        let { searchValue } = this.state;
        return (
            <div className="template-setting-left-sider template-setting-sider">
                {this.getModalTitleDom()}
                <div className='sider-content meta-tree'
                    style={{
                        height: '65vh',
                        // top: this.props.canSelectTreeNodeList.length === 0 && ShowTreeNodeSelect ? '80px' : '40px'
                    }}
                >
                    <NCDiv className='sider-tree' fieldid='addMeta' areaCode={NCDiv.config.TreeCom}>
                        {this.renderMetaTree(searchValue ? 'search' : 'default')}
                    </NCDiv>
                </div>
            </div>
        );
    }
    render() {
        let { json } = this.props;
        return (
            <HotKeysModal
                maskClosable={false}
                title={langCheck("ZoneSetting-000124", "pages", json)} /* 国际化处理： 添加元数据*/
                // mask={false}
                wrapClassName='meta-add-modal'
                visible={this.props.modalVisible}
                okText={langCheck("ZoneSetting-000005", "pages", json)} /* 国际化处理： 确定*/
                cancelText={langCheck("ZoneSetting-000006", "pages", json)} /* 国际化处理： 取消*/
                onOk={this.onOkMoveDialog}
                onCancel={this.showModalHidden}
                destroyOnClose={true}
                width={"50%"}
                fieldid='addMeta'
                titleFieldid={langCheck(
                    "ZoneSetting-000124",
                    "pages",
                    json,
                )} /* 国际化处理： 添加元数据*/
            >
                {/* {this.getContentDom()} */}
                {this.renderModalContent()}
            </HotKeysModal>
        );
    }
}
TreeModal.propTypes = {
    origTree: PropTypes.object,
    curTree: PropTypes.object,
    updateMetaTreeData: PropTypes.func,
    updateMetaTree: PropTypes.func,

};
export default connect(state => ({}), { updateSelectCard, updateSelectArea })(TreeModal);
